import { render } from "./PluginClientsList.vue?vue&type=template&id=09b68b04"
import script from "./PluginClientsList.vue?vue&type=script&lang=js"
export * from "./PluginClientsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__